import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 230px;
  min-height: 220px;
  background: var(--color-surface);
  box-shadow: 0 8px 10px var(--color-shadow);
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;

  .as-one {
    color: var(--color-text-muted);
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    text-transform: capitalize;
  }

  .content {
    padding: 20px 20px 7px;
  }

  .plan-name {
    color: var(--color-accent);
    font-size: 35.119px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    margin: -5px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .buttonContainer {
    height: 40px;
    width: calc(100% - 40px);
    margin: 0 20px;
    display: block;
    bottom: 0;
    position: absolute;
    border-top: 1px solid var(--color-border);

    button {
      border-radius: 10px;
      padding: 0;
      height: 36px;
      width: 100%;
    }
  }

  .price-active {
    color: var(--color-text-muted);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    display: flex;
    padding: 0 20px 5px;
    gap: 10px;
    justify-content: space-evenly;

    .divider {
      height: 41px;
      border-right: 1px solid var(--color-border);
    }
  }
`;
